/**
 * @generated SignedSource<<52a8b7e870959efaea28fb7fe55e013c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useDocumentsRelayUrlQuery$variables = {
  id: string;
};
export type useDocumentsRelayUrlQuery$data = {
  readonly getDocument: {
    readonly url: string | null | undefined;
  } | null | undefined;
};
export type useDocumentsRelayUrlQuery = {
  response: useDocumentsRelayUrlQuery$data;
  variables: useDocumentsRelayUrlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": {
      "throwOnFieldError": true
    },
    "name": "useDocumentsRelayUrlQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Document",
        "kind": "LinkedField",
        "name": "getDocument",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDocumentsRelayUrlQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Document",
        "kind": "LinkedField",
        "name": "getDocument",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1181fcce082d6433b0b03c56b85968f1",
    "id": null,
    "metadata": {},
    "name": "useDocumentsRelayUrlQuery",
    "operationKind": "query",
    "text": "query useDocumentsRelayUrlQuery(\n  $id: ID!\n) {\n  getDocument(id: $id) {\n    url\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0a8747a77c25820374311921859fbfed";

export default node;
